import { createContext, useContext } from 'react';

import { AceEditorTheme } from 'modules/aceEditor/types';
import noop, { NoOp } from 'utils/noop';

export type CustomFont = {
  name: string;
  fontFamily: string;
  fontWeight?: Record<number, string>;
  url: string;
};

export interface ContentEditorPreferencesContextState {
  addCustomFont: (customFont: CustomFont) => void;
  customFonts: CustomFont[];
  customFontsError: unknown;
  deleteCustomFont: (fontName: string) => void;
  editCustomFont: (originalFontName: string, customFont: CustomFont) => void;
  getCustomFonts: NoOp;
  isModalOpen: boolean;
  isFetchingCustomFonts: boolean;
  selectedSideBySideTheme: AceEditorTheme;
  setSelectedSideBySideTheme: (theme: AceEditorTheme) => void;
  toggleModal: (isOpen?: boolean) => void;
}

export const DEFAULT_CONTENT_EDITOR_PREFERENCE_CONTEXT_STATE: ContentEditorPreferencesContextState =
  {
    addCustomFont: noop,
    customFonts: [],
    customFontsError: '',
    deleteCustomFont: noop,
    editCustomFont: noop,
    getCustomFonts: noop,
    isModalOpen: false,
    isFetchingCustomFonts: false,
    selectedSideBySideTheme: AceEditorTheme.Monokai,
    setSelectedSideBySideTheme: noop,
    toggleModal: noop,
  };

export const ContentEditorPreferencesContext = createContext<ContentEditorPreferencesContextState>(
  DEFAULT_CONTENT_EDITOR_PREFERENCE_CONTEXT_STATE,
);

export const useContentEditorPreferencesContext = () => useContext(ContentEditorPreferencesContext);
